import React, { PureComponent } from "react";
import _ from "lodash";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
} from "reactstrap";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import {
  MDBDataTable,
  MDBBtn,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdbreact";
import axios from "axios";
import Select from "react-select";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import * as Excel from "exceljs";
/*import './App.css';*/
/*import { Multiselect } from 'multiselect-react-dropdown';
import { Dropdown } from 'semantic-ui-react'*/
import { Multiselect } from "multiselect-react-dropdown";

import MultiSelectReact from "multi-select-react";
/*import Multiselect from 'multiselect-dropdown-react';
 */ import { Field, reduxForm } from "redux-form";
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import MySelect from "../../../../shared/components/form/MySelect";
import LoadingOverlay from 'react-loading-overlay';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import PlusIcon from '../../../../images/plus.svg';
import NewDownloadExcel from '../../../../images/new_download_excel.png'
import "./styles.css";

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";
var url = window.location.hostname;
var port = window.location.port;
const options = [];
const optionsUser = [];
var rfqCheckedAll = {};
var zone_arr = [];
var aisles_arr = [];
var racks_arr = [];
var racks_aisle = [];

var options2 = [];

const options1 = [];

const data = [
  {
    name: "one",
    value: "one",
  },
  {
    name: "two",
    value: "two",
  },
  {
    name: "three",
    value: "three",
  },
  {
    name: "four",
    value: "four",
  },
  {
    name: "five",
    value: "five",
  },
  {
    name: "six",
    value: "six",
  },
];

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.fetchGRNData = this.fetchGRNData.bind(this);
    this.onSubmitCycleCount = this.onSubmitCycleCount.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.result = this.result.bind(this);
    this.onChangeVal3 = this.onChangeVal3.bind(this);
    this.onChangeVal = this.onChangeVal.bind(this);
    this.btnClick = this.btnClick.bind(this);
    this.processData = this.processData.bind(this);
    this.processData1 = this.processData1.bind(this);
    this.togglePressCancel = this.togglePressCancel.bind(this);
    this.messagetoggle = this.messagetoggle.bind(this);
    this.toggleReports = this.toggleReports.bind(this);
    this.messageToggleCycle = this.messageToggleCycle.bind(this);
    this.cancelMessageModal = this.cancelMessageModal.bind(this);
    this.cancelToggle = this.cancelToggle.bind(this);
    this.cancelMessageModalCycle = this.cancelMessageModalCycle.bind(this);
    this.confirmData = this.confirmData.bind(this);
    this.failedToggle = this.failedToggle.bind(this);
    this.failedToggleCycle = this.failedToggleCycle.bind(this);
    
    this.accessCookie = this.accessCookie.bind(this);
    this.changeType = this.changeType.bind(this);
    this.onChangeVal1 = this.onChangeVal1.bind(this);
    this.onChangeValStock = this.onChangeValStock.bind(this);
    this.onChangeVal2 = this.onChangeVal2.bind(this);
    this.setStockTake = this.setStockTake.bind(this);
    this.setCycleCount = this.setCycleCount.bind(this);
    this.onSubmitBtn = this.onSubmitBtn.bind(this);
    this.toggleAssignUser = this.toggleAssignUser.bind(this);
    this.failedToggleCancel = this.failedToggleCancel.bind(this);
    this.failedToggleCancelCycle = this.failedToggleCancelCycle.bind(this);
    this.toggleAssignUserCycleCount = this.toggleAssignUserCycleCount.bind(
      this
    );
    this.fetchCycleCountDashboard = this.fetchCycleCountDashboard.bind(this);
    this.onCancelCycleModal = this.onCancelCycleModal.bind(this);
    this.successToggle = this.successToggle.bind(this);
    this.successMessageToggle = this.successMessageToggle.bind(this);
    this.confirmData = this.confirmData.bind(this);
    this.AssignUser = this.AssignUser.bind(this);
    this.downloadSKU = this.downloadSKU.bind(this);
    this.exportToCSV = this.exportToCSV.bind(this);
    this.downloadCompleteStock = this.downloadCompleteStock.bind(this);
    this.downloadExcessStock = this.downloadExcessStock.bind(this);
    this.closeReportModal = this.closeReportModal.bind(this);
    /*this.optionClicked = this.optionClicked.bind(this);
   this.selectedBadgeClicked = this.selectedBadgeClicked.bind(this);*/
    this.multiSelectEl = [];

    this.state = {
      showPassword: false,
      options2: [],
      options1: [],
      loadingGRNData: false,
      cycleCountCancelModal: false,
      checkLoader: false,
      successMessageModal: false,
      SelectedBins: [],
      genloading: false,
      selectedOptionRadio: "",
      enableCreateCycle: true,
      loadBinData: false,
      schemas: [],
      showFetchGRNData: false,
      successModal: false,
      loadingprintbtn: false,
      modalAssignUser: false,
      zoneDataVal: [],
      removeSelectedDate: false,
      isReadinessCheck: true,
      modalCancel: false,
      isChecked: false,
      showFailedItem: false,
      isCheckedData: {},
      FailedItems: [],
      grnNumber: "",
      grnValues: "",
      grnLineValue: "",
      selectedOptions: "",
      failedMessage: "",
      changeStatus: "",
      alertMessage: "",
      messageModal: false,
      messageModalCycle: false,
      modalReport: false,
      disabledSubmitBtn: false,
      modalfailedCycle: false,
      showDashboardData: true,
      showRack: false,
      showZone: false,
    showProcess:false,
    onSelectProcess:"",
      showAisle: false,
      showBinTable: false,
      modalfailed: false,
      checkedAll: false,
      rfqCheckedAll: {},
      rfqChecked: {},
      postsGRN: [],
      postsProduct: [],
      multiSelect: [],
      postsProduct: [],
      tableRowsGRN: [],
      tableRowsProduct: [],
      ErrorRowData: [],
      binData: [],
      options: [],
      newArrayData: [],
      newArrayData1: [],
      totalScanCount: "",
      selectedUser: {},
      showAssignButton: true,
      showPrintButton: false,
      showSubmitBtn: false,
      clearData: false,
      showSelectedBin: false,
      optionSelected: null,
      optionSelected1: null,
      optionSelected2: null,
      isdisableAssignBtn: true,
    isdisableBinAssignBtn: false,
      optionForBinAddressDropdown: [],
      showBinAddressDropdown: false,
      value: "0",
      selectedBinAddress: "",
      all_binaddress: [],
      dropdownInProgress: false,
      containerOnKeyDown: false,
    loading_overlay: false,
    };
  }

  result(params) {
    console.log(params);
  }

  /* optionClicked(optionsList) {
        this.setState({ multiSelect: optionsList });
  }
  selectedBadgeClicked(optionsList) {
        this.setState({ multiSelect: optionsList });
  }*/

  setStockTake() {
    this.setState({
      selectedOptionRadio: "stockTake",
    });
  }

  exportToCSV(csvData, fileName) {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  }

  exportToCSV1 = (csvData, FileName) => {
    try {
      var workbook = new Excel.Workbook();
      console.log("exportToCSV", workbook);
      var worksheet = workbook.addWorksheet("My Sheet");

      worksheet.addRow({});
      worksheet.addRow([
        "",
        "Product",
        "PKD",
        "MRP",
        "QTY",
        "CBU Code",
        "Product",
        "PKD",
        "MRP",
        "QTY",
        "CBU Code",
        "",
        "Product",
        "PKD",
        "QTY",
        "Product",
        "PKD",
        "QTY",
      ]);

      csvData.map((item) =>
        worksheet.addRow([
          item["Bin Address"],
          item["System Sku Id"],
          item["System PKD"],
          item["System MRP"],
          item["System Qty"],
          item["System CBU"],
          item["Scanned Sku Id"],
          item["Scanned PKD"],
          item["Scanned MRP"],
          item["Scanned Qty"],
          item["Scanned CBU"],
          item["Status"],
          item["Excess Sku Id"],
          item["Excess PKD"],
          item["Excess Qty"],
          item["Short Sku Id"],
          item["Short PKD"],
          item["Short Qty"],
          item["Assigned User"],
        ])
      );

      worksheet.mergeCells("B1:F1");
      worksheet.mergeCells("G1:K1");
      worksheet.mergeCells("M1:O1");
      worksheet.mergeCells("P1:R1");

      worksheet.getCell("A1").value = "Bin Address";
      worksheet.getCell("B1").value = "System";
      worksheet.getCell("G1").value = "Physical/Scanned";
      worksheet.getCell("L1").value = "Status";
      worksheet.getCell("M1").value = "Excess (Physical)";

      worksheet.getCell("P1").value = "Short (Physical)";
      worksheet.getCell("S1").value = "Assigned User";

      // FileSaver.saveAs(worksheet, FileName + " Batch" + fileExtension);

      console.log("Generating data");
      workbook.xlsx.writeBuffer().then((data) => {
        var blob = new Blob([data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        console.log("Data generated");
        FileSaver.saveAs(blob, FileName + " Batch" + fileExtension);
      });
    } catch (error) {
      console.log(error);
    }
    // const ws = XLSX.utils.json_to_sheet(csvData);
    // const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    // const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    // const data = new Blob([excelBuffer], {type: fileType});
  };

  closeReportModal() {
    this.setState({ modalReport: false });
  }

  cancelToggle() {
    this.setState((prevState) => ({ modalCancel: !prevState.modalCancel }));
  }

  toggleReports(batchId) {
    this.setState((prevState) => ({
      modalReport: !prevState.modalReport,
      batchIdVal: batchId,
    }));
  }

  onCancelCycleModal(batchId) {
    this.setState({
      batchId: batchId,
    });
    this.setState((prevState) => ({
      cycleCountCancelModal: !prevState.cycleCountCancelModal,
    }));
  }

  downloadSKU() {
    console.log("sdfghjdfg");
    const payload = {
      batch_id: this.state.batchIdVal,

      location: this.state.selectedLocation,
  };

API.post('/cycle_count/cycleReconReportV2/', { param: payload })
      .then((response) => {
        console.log(response);
        console.log(JSON.stringify(response.data));
        this.exportToCSV1(
          response.data,
          this.state.batchIdVal + "_SKULevelReport"
        );
      })
      .catch(function (error) {});
  }

  downloadCompleteStock() {
    console.log("sdfghjdfg");
    const payload = {
      batch_id: this.state.batchIdVal,
      location: this.state.selectedLocation,
  };

API.post('/cycle_count/cycleCompleteStock/v1/', { param: payload })
      .then((response) => {
        console.log(response);
        console.log(JSON.stringify(response.data));
        this.exportToCSV(
          response.data,
          this.state.batchIdVal + "_completeStockReport"
        );
      })
      .catch(function (error) {});
  }

  downloadExcessStock() {
    console.log("sdfghjdfg");
    const payload = {
      batch_id: this.state.batchIdVal,
      location: this.state.selectedLocation,
  };

API.post('/cycle_count/cyclePhysicalExcessStock/v1/', { param: payload })
      .then((response) => {
        console.log(response);
        console.log(JSON.stringify(response.data));
        this.exportToCSV(
          response.data,
          this.state.batchIdVal + "_excessStockReport"
        );
      })
      .catch(function (error) {});
  }

  onCancel(batchId) {
  this.setState({
    loading_overlay: true
    })  
    const payload = {
      batch_id: this.state.batchId,
      location: this.state.selectedLocation,
  };
  addAnalytics('CC Dashboard', 'CC Cancel Batch', payload);

API.post('/cycle_count/cancelCycleCount/v1/', { param: payload })
      .then((response) => {
      
        console.log(response);
        this.setState({
      loading_overlay: false, 
          cycleCountCancelModal: false,
        });

        if (response.data.status == true) {
          this.setState({
            cancelReason: response.data.reason,
            modalCancel: true,
          });

          this.fetchCycleCountDashboard();
        } else if (response.data.status == false) {
          this.setState({
            cancelReason: response.data.reason,
            modalCancel: true,
          });

          this.fetchCycleCountDashboard();
        }
      })
      .catch(function (error) {});
  }

  AssignUser() {
    this.setState({
      selectedUser: {},
      modalAssignUserCycleCount: true,
      selectedOptions: "",
      newArrayData1: [],
    });

    /*var newArray = this.state.postsGRN.filter(status='UNHOLD');*/
    console.log(this.state.binData);
    var arrayCartData = this.state.binData.filter(
      (item) => item.isChecked === true
    );
    console.log(arrayCartData);
    this.setState({
      newArrayData1: arrayCartData,
    });
    console.log(this.state.newArrayData);

    var arr = [];

    for (var i = 0; i < arrayCartData.length; i++) {
      arr.push(arrayCartData[i].id);
    }
    //arr = [4341];
    console.log(arr);

    const payload = {
      bins: arr,
  };

API.post('/cycle_count/fetchCycleCountScanCount/v1/', { param: payload })
      .then((response) => {
        console.log(response);
        this.setState({
          totalScanCount: response.data.ScanCount,
        });

        console.log(this.state.totalScanCount);
      })
      .catch(function (error) {});
  }

  setCycleCount() {
    this.setState({
      selectedOptionRadio: "cycleCount",
    });
  }

  failedToggleCancel() {
    this.setState({
      modalfailed: false,
    });

    //window.location.reload();
  }

  failedToggleCancelCycle() {
    this.setState({
      modalfailedCycle: false,
    });

    window.location.reload();
  }

  onBlurBinAddress = (event) => {
   var selected_val = event.target.value;
   if(selected_val == "" || selected_val == undefined){
    this.setState({
    containerOnKeyDown : false,
    }) 
   }
  }

  onSelectBinAddress = (selected) => {
    let bin_address_arr = this.state.selectedBinAddress.split(",");

    var binData = [...this.state.binData];

    for (let i = 0; i < selected.length; i++) {
      bin_address_arr.push(selected[i]["label"]);
      binData.push({
        id: selected[i].value,
        isChecked: true,
        zone__zone_code: selected[i].zone__zone_code,
        zone_id: selected[i].zone_id,
        bin_address: selected[i].label,
      });
    }

    this.setState(
      {
        //selectedBinAddress: selected_value,
        all_binaddress : bin_address_arr,
        binData: binData,
        SelectedBins: binData,
        isdisableAssignBtn: false,
        showSelectedBin: true,
    isdisableBinAssignBtn:true,
      },
      () => {
        console.log(bin_address_arr);
        for (let i = 0; i < bin_address_arr.length; i++) {
          if (
            this.state.binData.some(
              (item) => item.bin_address === bin_address_arr[i]
            )
          ) {
            console.log(bin_address_arr[i]);
          } else {
            bin_address_arr.splice(i, 1);
          }
        }
        if (bin_address_arr.length == 0) {
          this.setState({
            isdisableAssignBtn: true,
            containerOnKeyDown: false,
          });
        }
      }
    );
  };
  onBinAddressKeyup = (event) => {
    this.setState({
      showZone: false,
      dropdownInProgress: true,
    });
    var selectedval = { ...this.state.selectedBinAddress };
    selectedval = event.target.value;
    this.setState({
      selectedBinAddress: selectedval,
    });
    
    if(selectedval == "" || selectedval== undefined){
      console.log(selectedval);
      this.setState({
        containerOnKeyDown: false,
      })
      return false;
    }
    const payload = {
      location: this.state.selectedLocation,
      bin_address: event.target.value,
  };

API.post('/inventory/fetchBins/v1/', { param: payload })
      .then((response) => {
        //console.log(response);
        //optionForBinAddressDropdown
        let options = [];
        for (var i = 0; i < response.data.length; i++) {
          var orderData = {};
          orderData["label"] = response.data[i].bin_address;
          orderData["value"] = response.data[i].id;
          orderData["zone_id"] = response.data[i].zone_id;
          orderData["zone__zone_code"] = response.data[i].zone__zone_code;
          //orderData["id"] = response.data.zones[i].id;

          options.push(orderData);
        }
        if(selectedval == "" || selectedval == undefined){
          this.setState({
            optionForBinAddressDropdown: options,
            dropdownInProgress: false,
            containerOnKeyDown: false,
          })
          return false;
        }else{
          this.setState({
            optionForBinAddressDropdown: options,
            dropdownInProgress: false,
            containerOnKeyDown: true,
          });  
        }
        if(response.daa.length == 0){
          this.setState({
            containerOnKeyDown: false,
          });  
        }
      })
      .catch(function (error) {});
  };


  onReadinessCheck = () =>{
    this.setState({
      checkLoader: true
    })
    const payload = {
      location: this.state.selectedLocation,
    };
    addAnalytics('CC Dashboard', 'CC Readiness Check', payload);

    API.post('/cycle_count/ccReadiness', { param: payload })
      .then((response) => {
        console.log(response);
       if(response.data.status === true){
        this.setState({
          enableCreateCycle: false,
          success_message: response.data.reason,
          checkLoader: false

        })
        this.successMessageToggle();
       }else{
        this.setState({
          enableCreateCycle: true,
          failedMessage:response.data.reason,
          checkLoader: false
        })
        this.failedToggle();
       }

      })
      .catch(function (error) {});

  }

  onSubmitBtn() {
    addAnalytics('CC Dashboard', 'Redirect to Create New');

    window.location.href = "/maintenance/cycleCount/create_new"
  }

  onSubmitCycleCount() {
    this.setState({
      loadBinData: true,
    });
    console.log(zone_arr);
    console.log(racks_arr);
    console.log(aisles_arr);

    /*this.toggleAssignUserCycleCount();*/

    const payload = {
      location: this.state.selectedLocation,
      rack: racks_arr,
      aisle: aisles_arr,
      zone: zone_arr,
      rack_aisle: racks_aisle,
  };

API.post('/cycle_count/binsCycleCount/v1/', { param: payload })
      .then((response) => {
        console.log(response);
        this.setState({
          showBinTable: true,
          binData: response.data,
          loadBinData: false,
        });

        let newBinData = this.state.binData.map((item) => ({
          ...item,
          isChecked: false,
        }));

        this.setState({
          binData: newBinData,
        });

        console.log(this.state.binData);
        /* this.setState({
            rfqData: response.data.message.info,
            rfqCheckedAll: rfqCheckedAll,
            rfqChecked: rfqChecked,
            rfqDataDetails: arr,
            isActive: false
          }, () => console.log(this.state.rfqCheckedAll))*/
      })
      .catch(function (error) {});
  }

  changeType = (selectedOption) => {
    if (selectedOption.value === "stock_pick") {
      this.setState({
        showBinTable: true,
        showZone: false,
        showAisle: false,
        showRack: false,
      });
    } else if (selectedOption.value === "cycle_count") {
      this.setState({
        showBinTable: false,
        showZone: true,
      });
    }
  };

  fetchUserList() {
    const payload = {
      location: this.state.selectedLocation,
  };

API.post('/auth/users/getusers', { param: payload })
      .then((response) => {
        console.log(response);
        for (var i = 0; i < response.data.length; i++) {
          // <---- Move declaration inside loop

          var orderData = {};
          orderData["label"] = response.data[i].userName;
          orderData["value"] = response.data[i].userId;

          optionsUser.push(orderData);
        }

        /* console.log(this.state.options);*/
      })
      .catch(function (error) {});
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    }
     else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8090";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
     this.setState({
     
      userName: cookieUsername,
      selectedLocation: Location,
    });



    localStorage.setItem("userName", username);
  }

  

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  messagetoggle() {
    this.setState({
      messageModal: true,
    });
  }

  messageToggleCycle() {
    this.setState({
      messageModalCycle: true,
    });
  }

  toggleAssignUser() {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({
      modalAssignUser: !prevState.modalAssignUser,
    }));
  }

  successToggle() {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({ successModal: !prevState.successModal }));
    window.location.reload();
  }

  successMessageToggle() {
    this.setState((prevState) => ({ successMessageModal: !prevState.successMessageModal }));
  }


  failedToggle() {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({ modalfailed: !prevState.modalfailed }));
  }

  failedToggleCycle() {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({
      modalfailedCycle: !prevState.modalfailedCycle,
    }));
  }

  toggleAssignUserCycleCount() {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({
      modalAssignUserCycleCount: !prevState.modalAssignUserCycleCount,
    }));
  }

  cancelMessageModalCycle() {
    var arr = [];

    _.map(this.state.selectedUser, (item, key) => {
      var bin_arr = [];
      var orderData = {};
      console.log(key);
      console.log(item);
      orderData["zone"] = parseInt(key);
      orderData["users"] = item[0];
      /*item[1].map(( item1 , index ) => (
        console.log(item1)
        bin_arr.push(item1.bin_address.push)


      ))*/

      item[1].map((item1) => {
        console.log(item1.bin_address);
        bin_arr.push(item1.id);
      });

      orderData["bins"] = bin_arr;

      arr.push(orderData);
    });

    console.log(arr);

    const payload = {
      create: true,
      location: this.state.selectedLocation,
      req_type: "cc",
      cycle_data: arr,
  };

API.post('/cycle_count/createCycleCount/v1/', { param: payload })
      .then((response) => {
        console.log(response);
        this.setState({
          messageModalCycle: false,
        });
        this.successToggle();
      })
      .catch(function (error) {});
  }

  cancelMessageModal() {
    this.setState({
      loadingprintbtn: true,
    });

    console.log(this.state.selectedUser);
    var arr = [];

    _.map(this.state.selectedUser, (item, key) => {
      var orderData = {};
      console.log(key);
      console.log(item);
      orderData["zone"] = parseInt(key);
      orderData["users"] = item[0];

      arr.push(orderData);
    });

    console.log(arr);

    const payload = {
      create: true,
      location: this.state.selectedLocation,
      req_type: "st",
      cycle_data: arr,
  };

API.post('/cycle_count/createCycleCount/v1/', { param: payload })
      .then((response) => {
        if (response.data.status_code === 200) {
          this.setState({
            messageModal: false,
          });
          this.successToggle();
        }
      })
      .catch(function (error) {});
  }

  confirmData() {
    this.setState({
      messageModal: false,
    });

    this.setState({
      loadingprintbtn: true,
    });

    console.log(this.state.selectedUser);
    var arr = [];

    _.map(this.state.selectedUser, (item, key) => {
      var orderData = {};
      console.log(key);
      console.log(item);
      orderData["zone"] = parseInt(key);
      orderData["users"] = item[0];

      arr.push(orderData);
    });

    console.log(arr);

    const payload = {
      create: true,
      location: this.state.selectedLocation,
      req_type: "st",
      cycle_data: arr,
  };

API.post('/cycle_count/createCycleCount/v1/', { param: payload })
      .then((response) => {
        if (response.data.status_code === 200) {
          this.setState({
            messageModal: false,
          });
          this.successToggle();
        }
      })
      .catch(function (error) {});
  }

  processData() {
    this.setState({
      loadingprintbtn: true,
    });

    console.log(this.state.selectedUser);
    var arr = [];

    _.map(this.state.selectedUser, (item, key) => {
      var orderData = {};
      console.log(key);
      console.log(item);
      orderData["zone"] = parseInt(key);
      orderData["users"] = item[0];

      arr.push(orderData);
    });

    console.log(arr);

    const payload = {
      create: false,
      location: this.state.selectedLocation,
      req_type: "st",
      cycle_data: arr,
  };

API.post('/cycle_count/createCycleCount/v1/', { param: payload })
      .then((response) => {
        console.log(response);
        if (response.data.status_code === 201) {
          this.setState({
            failedMessage: response.data.reason,
          });
          this.toggleAssignUser();
          this.failedToggle();
        }

        if (
          response.data.status_code === 200 &&
          response.data.failed.length === 0
        ) {
          this.setState({
            alertMessage: "Are you sure you want to confirm ? ",
          });
          this.toggleAssignUser();
          this.messagetoggle();
        }

        if (
          response.data.status_code === 200 &&
          response.data.failed.length > 0
        ) {
          this.setState({
            failedMessage: "This file contains some errors",
            showFailedItem: true,
            FailedItems: response.data.failed,
          });
          this.toggleAssignUser();
          this.failedToggle();
        }
      })
      .catch(function (error) {});
  }

  processData1() {
    this.setState({
      loadingprintbtn: true,
    });

    var arr = [];

    _.map(this.state.selectedUser, (item, key) => {
      var bin_arr = [];
      var orderData = {};
      console.log(key);
      console.log(item);
      orderData["zone"] = parseInt(key);
      orderData["users"] = item[0];
      /*item[1].map(( item1 , index ) => (
        console.log(item1)
        bin_arr.push(item1.bin_address.push)


      ))*/

      item[1].map((item1) => {
        console.log(item1.bin_address);
        bin_arr.push(item1.id);
      });

      orderData["bins"] = bin_arr;

      arr.push(orderData);
    });

    console.log(arr);

    const payload = {
      create: false,
      location: this.state.selectedLocation,
      req_type: "cc",
      cycle_data: arr,
  };

API.post('/cycle_count/createCycleCount/v1/', { param: payload })
      .then((response) => {
        console.log(response);
        if (response.data.status_code === 201) {
          this.setState({
            failedMessage: response.data.reason,
          });
          this.toggleAssignUserCycleCount();
          this.failedToggleCycle();
        }

        if (
          response.data.status_code === 200 &&
          response.data.failed.length === 0
        ) {
          this.setState({
            alertMessage: "Are you sure you want to confirm ? ",
          });
          this.toggleAssignUserCycleCount();
          this.messageToggleCycle();
        }

        if (
          response.data.status_code === 200 &&
          response.data.failed.length > 0
        ) {
          this.setState({
            failedMessage: "This file contains some errors",
            showBinTable: false,
            showZone: false,
            showFailedItemCycle: true,
            FailedItems: response.data.failed,
          });
          this.toggleAssignUserCycleCount();
          this.failedToggleCycle();
        }
      })
      .catch(function (error) {});
  }

  togglePressCancel() {
    this.setState({
      modal: false,
      selectedOptions: "",
      selectedUser: {},
    });
  }

  handleChange(event) {
    this.setState({ value: event.target.data, grnValues: event.target.value });

    localStorage.setItem("grnValues", event.target.value);

    this.fetchGRNData();
  }

  onChangeVal1 = (options, id, bin_items) => {
    const { selectedUser } = this.state;
    console.log(options);
    /*selectedUser[id] = options.map(item => [item.value])*/
    var data = [];
    for (var i = 0; i < options.length; i++) {
      data.push(options[i]["value"]);
    }
    console.log(data);
    selectedUser[id] = [];
    selectedUser[id].push(data);
    selectedUser[id].push(bin_items);
    this.setState(
      {
        selectedUser,
      },
      (e) => console.log(this.state.selectedUser)
    );
  };

  onChangeVal = (options, id, bin_items) => {
    const { selectedUser } = this.state;
    console.log(options);
    /*selectedUser[id] = options.map(item => [item.value])*/
    var data = [];
    for (var i = 0; i < options.length; i++) {
      data.push(options[i]["value"]);
    }
    console.log(data);
    selectedUser[id] = [];
    selectedUser[id].push(data);
    selectedUser[id].push(bin_items);
    this.setState(
      {
        selectedUser,
      },
      (e) => console.log(this.state.selectedUser)
    );
  };

  onChangeValStock = (options, id, bin_items) => {
    const { selectedUser } = this.state;
    console.log(options);
    /*selectedUser[id] = options.map(item => [item.value])*/
    var data = [];
    for (var i = 0; i < options.length; i++) {
      data.push(options[i]["value"]);
    }
    console.log(data);
    selectedUser[id] = [];
    selectedUser[id].push(data);
    selectedUser[id].push(bin_items);
    this.setState(
      {
        selectedUser,
      },
      (e) => console.log(this.state.selectedUser)
    );
  };
  
  onSelectProcess = selected => {
  if(parseInt(selected.value) == 1){
    this.setState({
      showBinAddressDropdown : true,
      showZone : false,
      onSelectProcess:selected,
      isdisableBinAssignBtn:false,
      showSelectedBin:false,
      showBinTable: false,
      SelectedBins:[],
      binData: []
    })
  }

  if(parseInt(selected.value) == 2){
    this.setState({
      showBinAddressDropdown : false,
      showZone : true,
      onSelectProcess:selected,
      isdisableBinAssignBtn:false,
      SelectedBins:[],
      binData:[]
    })
  }
  
  }

  onChangeVal3 = (selected) => {
    const { selectedUser } = this.state;
    
    let selectedLabel = selected.map((item) => item.value);
    let unique_aisle = [];
    let new_selectedZone = []
    let selectedZone = options1.filter(
      (item) => selectedLabel.indexOf(item.zone) != -1
    );

    
    for(let i=0;i < selectedZone.length;i++){
      if(unique_aisle.indexOf(parseInt(selectedZone[i]["value"])) <= -1){
        unique_aisle.push(parseInt(selectedZone[i]["value"]));
        new_selectedZone.push(selectedZone[i]);
      }else{
        selectedZone.splice(i,1);
      } 
    }

    this.setState({
      options1: new_selectedZone,
      showAisle: true,
      showRack: false,
      showSubmitBtn: false,
      removeSelectedDate: true,
      clearData: true,
      zoneDataVal: selected,
      optionSelected: selected,
      showBinAddressDropdown: false,
    });
    console.log(this.state.zoneDataVal);

    zone_arr = [];

    for (var i = 0; i < selected.length; i++) {
      zone_arr.push(selected[i].id);
    }
    console.log(zone_arr);
    /*selectedUser[id] = options.map(item => item.value)
        this.setState({
          selectedUser
        }, e => console.log(this.state.selectedUser))*/
  };

  onChangeVal1 = (selected) => {
    const { selectedUser } = this.state;
  
    let selectedLabel = [];
  
  for(let i=0;i < this.state.optionSelected.length;i++){
    let mapped_data = selected.map((item) => item.label + this.state.optionSelected[i].value);
    for(let j=0;j < mapped_data.length;j++){
      selectedLabel.push(mapped_data[j]);
    }
  }
  
  console.log(this.state.selectedLabel);

  let selectedRack = options2.filter(
    (item) => selectedLabel.indexOf(item.aisle + item.zone__zone_no) != -1
  );

  console.log(selectedRack);
  let unique_aisle = [];
  let new_selectedRack = [];
  for(let i=0;i < selectedRack.length;i++){
      if(unique_aisle.indexOf(selectedRack[i]["value"].toString()) <= -1){
        unique_aisle.push(selectedRack[i]["value"].toString());
        new_selectedRack.push(selectedRack[i]);
      }else{
        selectedRack.splice(i,1);
      } 
    }
   // console.log(options2);

    //console.log(options);

    this.setState({
      options2: new_selectedRack,
      showRack: true,
      optionSelected1: selected,
    });

    //console.log(selectedRack);
    //console.log(this.state.options2);
    aisles_arr = [];

    for (var i = 0; i < selected.length; i++) {
      aisles_arr.push(selected[i].value);
    }

    /*selectedUser[id] = options.map(item => item.value)
        this.setState({
          selectedUser
        }, e => console.log(this.state.selectedUser))*/
  };

  onChangeVal2 = (selected) => {
    const { selectedUser } = this.state;
    console.log(selected);

    this.setState({
      showBinTable: false,
      showSubmitBtn: true,
      optionSelected2: selected,
    });

    racks_arr = [];
    racks_aisle = [];
    console.log(selected);
    for (var i = 0; i < selected.length; i++) {
      racks_arr.push(selected[i].rackCode);
      racks_aisle.push(selected[i].label);
    }

    /*selectedUser[id] = options.map(item => item.value)
        this.setState({
          selectedUser
        }, e => console.log(this.state.selectedUser))*/
  };

  btnClick(putAwayId, Status) {
    /* options=[];*/

    console.log(Status);
    if (Status === "UNHOLD") {
      this.setState({
        changeStatus: "hold",
      });
    } else {
      this.setState({
        changeStatus: "unhold",
      });
    }

    var arr = [];
    var orderData = {};
    orderData["putawayHistoryId"] = putAwayId;

    if (Status === "UNHOLD") {
      orderData["changeStatus"] = "hold";
    } else {
      orderData["changeStatus"] = "unhold";
    }

    arr.push(orderData);

    const payload = {
      arr_data: arr,
      location: this.state.selectedLocation,
      create: true,
  };

API.post('/picking/updateHoldStatus/v1/', { param: payload })
      .then((response) => {
        console.log(response);
        /*alert(response.data.success_response[0].message);*/
        this.setState({
          alertMessage: response.data.success_response[0].message,
          messageModal: true,
        });

        this.fetchGRNData();
      })
      .catch(function (error) {});
  }

  checkAll() {
    if (this.state.isChecked === false) {
      this.setState({
        isChecked: true,
        showSelectedBin: true,
      });

      let newBinData = this.state.binData.map((item) => ({
        ...item,
        isChecked: true,
      }));

      this.setState({
        binData: newBinData,
        SelectedBins: newBinData,
      });

      console.log(this.state.binData);
      this.setState({
        isdisableAssignBtn: false,
      });
    } else if (this.state.isChecked === true) {
      this.setState({
        isChecked: false,
        showSelectedBin: false,
      });

      let newBinData = this.state.binData.map((item) => ({
        ...item,
        isChecked: false,
      }));

      this.setState({
        binData: newBinData,
      });

      console.log(this.state.binData);
      this.setState({
        isdisableAssignBtn: true,
      });
    }
  }

  checkedSingle(index) {
    console.log(this.state.binData);
    let newData = this.state.binData;
    if (newData[index].isChecked === false) {
      newData[index].isChecked = true;
      this.setState({
        showSelectedBin: true,
        isdisableAssignBtn: false,
      });
    } else if (newData[index].isChecked === true) {
      newData[index].isChecked = false;
      this.setState({
        isdisableAssignBtn: true,
      });
    }

    console.log(newData);
    this.setState({
      genloading: !this.state.genloading,
      binData: newData,
    });

    let selectedbin = this.state.binData.filter(
      (item) => item.isChecked == true
    );

    this.setState({
      SelectedBins: selectedbin,
    });

    /*let newBinData =
      this.state.binData.map(item => ({
        ...item,
        isChecked: true
      }))

      this.setState({
        binData: newBinData
      })

      console.log(this.state.binData);

    let newData = this.state.binData;
      newData[index].isChecked  =  true;
      this.setState({
        binData: newData
      })*/
    this.state.binData.map((item) => ({
      /*if(item.isChecked == true){
      this.setState({
        isdisableAssignBtn : false
      })
    }*/
    }));
  }

  fetchGRNData() {
    var grnVal = localStorage.getItem("grnValues");
    this.setState({
      showFetchGRNData: true,
      loadingGRNData: true,
    });

    const payload = {
    
  };

API.post('/picking/fetchgrnInfo/v1/', { param: payload })

      .then((response) => response.data)

      .then((data) => {
        // console.log(data);

        // if (err) throw err;

        this.setState({
          postsGRN: data,
          grnValues: data[0].grnNumber,
          grnLineValue: data[0].gnrLineNumber,
        });
        /*console.log(this.state.postsGRN[0].grnNumber)*/
      })

      .then(async () => {
        this.setState({
          tableRowsGRN: this.assemblePostsGRN(),
          isLoading: false,
          loadingGRNData: false,
        });

        console.log(this.state.tableRowsGRN);
      });
  }

  assemblePostsGRN = () => {
    let postsGRN = this.state.postsGRN.map((post, index) => {
      return {
        serial: index + 1,

        /*grnNumber: post.grnNumber,

          gnrLineNumber: post.gnrLineNumber,*/

        /*putawayHistoryId: post.putawayHistoryId,*/
        /*status: post.status == 'UNHOLD' ? <MDBBtn onClick={r => this.btnClick(post.putawayHistoryId, post.status)} style={{backgroundColor: '#4ce1b6' , color: '#fff'}} color="default" rounded size="sm">Hold</MDBBtn> : <MDBBtn  style={{backgroundColor: '#de5361', color: '#fff'}} onClick={r => this.btnClick(post.putawayHistoryId, post.status)} rounded size="sm">Release</MDBBtn>,*/
        status:
          post.status == "UNHOLD" ? (
            <span
              onClick={(r) => this.btnClick(post.putawayHistoryId, post.status)}
              style={{ color: "red", cursor: "pointer" }}
            >
              Hold
            </span>
          ) : (
            <span
              style={{ color: "green", cursor: "pointer" }}
              onClick={(r) => this.btnClick(post.putawayHistoryId, post.status)}
            >
              Unhold
            </span>
          ),

        binId: post.binId,

        zone_name: post.zoneName,

        zone_id: post.zoneId,

        lbskuid: post.lbSKUId,

        batch: post.batch,

        mrp: post.mrp,

        receivedIcldQuantity: post.receivedIcldQuantity,

        testerQuantity: post.testerQuantity,

        looseQuantity: post.looseQuantity,

        stnDate: post.stnDate,

        stnNumber: post.stnNumber,

        pkd: post.pkd,

        upc: post.upc,

        total_quantity: post.binFilledQty,

        /*grnDateTime: post.grnDateTime,*/

        /*basePackDesc: post.basePackDesc,*/

        fastMoving: post.fastMoving,

        crateId: post.crateId,
      };
    });

    return postsGRN;
  };

  fetchCycleCountDashboard() {
    const payload = {
      location: this.state.selectedLocation,
  };

API.post('/cycle_count/cycleDashboard/v1/', { param: payload })

      .then((response) => response.data)

      .then((data) => {
        // console.log(data);

        // if (err) throw err;

        this.setState({ postsProduct: data });

        console.log(this.state.postsProduct);

        var filterPostData = [];

        filterPostData = data.filter((item) => item.status === "Active");

        console.log(filterPostData);

        if (filterPostData.length > 0) {
          this.setState({
            disabledSubmitBtn: true,
          });
        }
      })

      .then(async () => {
        this.setState({
          tableRowsProduct: this.assemblePostsProduct(),
          isLoading: false,
          genloading: false,
        });

        console.log(this.state.tableRowsProduct);
      });
  }

  componentDidMount() {
    //this.fetchUserList();
    var virtual_bins = this.getCookie("virtual_bins")
    this.setState({
      isReadinessCheck: virtual_bins,
    });

    if(virtual_bins == "true"){
      this.setState({
        enableCreateCycle: true,
        isReadinessCheck: true
      })
    }else{
      this.setState({
        enableCreateCycle: false,
        isReadinessCheck: false
      })
    }

    this.fetchCycleCountDashboard();
  }
  TaskConfirmClick = (id) => {
    addAnalytics('CC Dashboard', 'Redirect to CC Confirmation');

    localStorage.setItem('batch',id);window.location.href = "/maintenance/cycleCountConfirmation";
  };
  assemblePostsProduct = () => {
    console.log("cvbn");

    console.log(this.state.postsProduct);

    let postsProduct = this.state.postsProduct.map((post) => {
      return {
     
         action: post.status === "Active" ? (
            <Button
              type="button"
              className="btn btn-primary-outline"
              style={{
                cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                backgroundColor: '#FFFFFF',
                fontWeight: 'bold',
                fontSize: 15,
                color: '#333333', // Set text color
                alignItems: 'center', // Center items vertically
                textAlign: 'center'
              }}
              id="button_cancel"
              onClick={(r) => this.onCancelCycleModal(post.id)}
            >
              Cancel
            </Button>
          ) : (
            <span></span>
          ),
        batch :post.status == "Active" ? (
              <a
                style={{ cursor: "pointer", color: "rgb(62, 163, 252)" }}
                onClick={() => this.TaskConfirmClick(post.id)}
              >
                {post.batch_name}
              </a>
            ) : (post.batch_name),
       /* status:
          post.status == "Active" ? (
            <span style={{ color: "orange", fontWeight: "bold" }}>
              {post.status}
            </span>

          ) : (
            <span
              style={{
                color: post.status == "Completed" ? "green" : "red",
                fontWeight: "bold",
              }}
            >
              {" "}
              {post.status}
            </span>
          ),*/
           status:
          post.status == "Active" ? (
          
            <div className="pending_div"><span className="pending_text">{post.status}</span></div>
            
          ) : (
            post.status == "Completed" ?

            <div className="completed_div"><span className="approved_text">{post.status}</span></div>
            
            :

            <div className="rejected_div"><span className="rejected_text">{post.status}</span></div>


          ),
        added_on: post.added_on,
        task_created: post.task_created,

        users: post.users,

        task_pushed: post.task_pushed,

        updated_from_mobile: post.update_from_mobile,

        reconciled: post.reconciled,

        reconciled_processed: post.reconciled_processed,

        recheck: post.recheck,

        report: 
    /* post.status == "Completed" ? (
          <span
            onClick={(r) => this.toggleReports(post.id)}
            class="lnr lnr-download"
            style={{ color: "#0F52BA", fontSize: 22, fontWeight: "bold",marginLeft:'50px' }}
          ></span>
        ) : (
          <span
            class="lnr lnr-download isDisabled"
            style={{ color: "#0F52BA", fontSize: 22, fontWeight: "bold",marginLeft:'50px',opacity:0.3 }}
          ></span>
        )*/

         post.status == "Completed" ? (
         

          <Button
              type="button"
              className="btn btn-primary-outline"
              style={{
                cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                backgroundColor: '#FFFFFF',
                fontWeight: 'bold',
                fontSize: 15,
                color: '#33A0FF', // Set text color
                border: '2px solid white',  // White border
                alignItems: 'center',  // Center items vertically
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',  // Subtle shadow for raised effect
                transition: 'box-shadow 0.3s ease',  
              }}
              id="button_excel_download"
              onClick={(r) => this.toggleReports(post.id)}
            >
              <img
                        src={NewDownloadExcel}
                        alt="Plus"
                        style={{ width: '20px',marginRight: 5 }} // Adjust size as needed
                    />
              Download
            </Button>
        ) : (
          <span
            
            style={{ color: "#0F52BA", fontSize: 22, fontWeight: "bold",marginLeft:'50px',opacity:0.3 }}
          ></span>
        )

      };
    });

    return postsProduct;
  };

  toggle() {
    this.setState({
      selectedUser: {},
      selectedOptions: "",
      modal: true,
      newArrayData1: [],
    });

    /*var newArray = this.state.postsGRN.filter(status='UNHOLD');*/
    var arrayCartData = this.state.postsGRN.filter(
      (item) => item.status === "UNHOLD" && item.zoneName != null
    );
    console.log(arrayCartData);
    this.setState({
      newArrayData1: arrayCartData,
    });
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };
  
  removeBin = bin_address => {
  let bin_address_arr = [...this.state.binData];
  let selected_bins = [...this.state.SelectedBins];
  for(let i=0;i< bin_address_arr.length;i++){
    if(bin_address_arr[i] != "" && bin_address_arr[i] != undefined){
      if(bin_address_arr[i]["bin_address"] == bin_address){
        bin_address_arr.splice(i,1);
      }
    }
    if(selected_bins[i] != "" && selected_bins[i] != undefined){
      if(selected_bins[i]["bin_address"] == bin_address){
        selected_bins.splice(i,1);
      }
    }
  }
  
  this.setState({
    binData : bin_address_arr,
    SelectedBins : selected_bins
  }, () => {
    console.log(this.state.binData);
    if(this.state.SelectedBins.length == 0){
      this.setState({
        showSelectedBin : false,
      })
    }
  });
  }

  render() {
    const { handleSubmit, reset, t } = this.props;
    const {
      showPassword,
      newArrayData,
      newArrayData1,
      selectedUser,
      modalReport,
    } = this.state;
    const { modal, modalCancel } = this.state;
    const { modalAssignUser, modalAssignUserCycleCount, successMessageModal } = this.state;
    const {
      messageModal,
      modalfailed,
      successModal,
      modalfailedCycle,
      messageModalCycle,
      cycleCountCancelModal,
    } = this.state;
    const uniqueZoneData1 = {};
    const uniqueZoneData = {};
    newArrayData.map((item) => {
      if (!uniqueZoneData[item.zone_id]) {
        uniqueZoneData[item.zone_id] = {
          zoneId: item.zone_no,
          zoneName: item.zone_code,
          id: item.zone_id,
          items: [],
        };
      }
      uniqueZoneData[item.zone_id].items.push(item);
    });

    newArrayData1.map((item) => {
      if (!uniqueZoneData1[item.zone_id]) {
        uniqueZoneData1[item.zone_id] = {
          zoneId: item.zone_id,
          zoneName: item.zone__zone_code,
          items: [],
        };
      }
      uniqueZoneData1[item.zone_id].items.push(item);
    });

    console.log(uniqueZoneData1);
    console.log(uniqueZoneData);
    console.log(this.state.binData);
    console.log(this.state.zoneDataVal);
    console.log(this.state.zoneDataVal.length);
    console.log("virtual_bins", this.state.isReadinessCheck)

    const productData = {
      columns: [
    
        {
          label: "Action",

          field: "action",

          width: 120,
        },

        {
          label: "Batch",

          field: "batch",

          width: 140,
        },

        {
          label: "Status",

          field: "status",
          width: 120,
        },

        {
          label: "Added on",

          field: "added_on",
          width: 180,
        },

        {
          label: "Task Created",

          field: "task_created",

          width: 150,
        },

        {
          label: "Users",

          field: "users",

          width: 110,
        },

        {
          label: "Task Pushed",

          field: "task_pushed",

          width: 150,
        },

        {
          label: "Updated From Mobile",

          field: "updated_from_mobile",

          width: 180,
        },

        {
          label: "Reconciled",

          field: "reconciled",

          width: 100,
        },

        {
          label: "Reconciled Processed",

          field: "reconciled_processed",

          width: 180,
        },

        {
          label: "Recheck",

          field: "recheck",

          width: 100,
        },

        {
          label: "Download Reports",

          field: "report",

          width: 150,
        },

        
      ],

      rows: this.state.tableRowsProduct,
    };

    const GRNData = {
      columns: [
        /* {

          label:'GRN Number',

          field:'grnNumber',

        },

        {

          label:'GRN Line Number',

          field:'gnrLineNumber',

        },*/

        /*{

          label:'PutAway History',

          field:'putawayHistoryId',

        },*/
        {
          label: "S No.",

          field: "serial",
          width: 180,
        },

        {
          label: "Action",

          field: "status",
          width: 180,
        },

        {
          label: "BIN Id",

          field: "binId",
          width: 180,
        },

        {
          label: "Zone Name",

          field: "zone_name",
          width: 180,
        },

        {
          label: "Zone Id",

          field: "zone_id",
          width: 180,
        },

        {
          label: "LB SKU ID",

          field: "lbskuid",
          width: 180,
        },

        {
          label: "Batch",

          field: "batch",
          width: 180,
        },

        {
          label: "MRP",

          field: "mrp",
          width: 180,
        },

        {
          label: "ICLD Quantity (Box)",

          field: "receivedIcldQuantity",
          width: 180,
        },

        {
          label: "Tester Quantity (pcs)",

          field: "testerQuantity",
          width: 180,
        },

        {
          label: "Loose Quantity (pcs)",

          field: "looseQuantity",
          width: 180,
        },

        {
          label: "STN Date",

          field: "stnDate",
          width: 180,
        },

        {
          label: "STN Number",

          field: "stnNumber",
          width: 180,
        },

        {
          label: "PKD",

          field: "pkd",
          width: 180,
        },

        {
          label: "UPC",

          field: "upc",
          width: 180,
        },

        {
          label: "Total Quantity (pcs)",

          field: "total_quantity",
          width: 180,
        },

        /*{

          label:'GRN Date Time',

          field:'grnDateTime',

        },*/

        /*{

          label:'Base Pack Desc',

          field:'basePackDesc',

        },*/

        {
          label: "Fast Moving",

          field: "fastMoving",
          width: 180,
        },

        {
          label: "Crate Id",

          field: "crateId",
          width: 180,
        },
      ],

      rows: this.state.tableRowsGRN,
    };

    const selectedOptionsStyles = {
      color: "#3c763d",
      backgroundColor: "#dff0d8",
    };
    const optionsListStyles = {
      backgroundColor: "#dff0d8",
      color: "#3c763d",
    };

    return (
      <Col xl={12}>
    {this.state.loading_overlay && <LoadingOverlay active={true} spinner text='' /> }
        <Card>
         
            <form className="form form--inline" style={{marginTop: 10}} onSubmit={handleSubmit}>
              <div
                className="form__form-group col-xl-2"
                style={{ display: "none" }}
              >
                <div
                  className="form__form-group-field col-xl-6"
                  style={{ display: "contents" }}
                >
                  <div className="radio">
                    <label>
                      <input
                        type="radio"
                        style={{ marginRight: 22 }}
                        value="stockTake"
                        onClick={this.setStockTake}
                        checked={this.state.selectedOptionRadio === "stockTake"}
                      />
                      Stock Take
                    </label>
                  </div>
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{ display: "none" }}
              >
                <div
                  className="form__form-group-field col-xl-6"
                  style={{ display: "contents" }}
                >
                  <div className="radio">
                    <label>
                      <input
                        style={{ marginRight: 22 }}
                        type="radio"
                        value="cycleCount"
                        onClick={this.setCycleCount}
                        checked={
                          this.state.selectedOptionRadio === "cycleCount"
                        }
                      />
                      Cycle Count
                    </label>
                  </div>
                </div>
              </div>

              {this.state.isReadinessCheck  &&
               <div
                className="form__form-group col-xl-2"
                style={{ display: "inline-flex" }}
              >
                <div
                  className="form__form-group-field col-xl-6"
                  style={{ display: "contents" }}
                >
                  <ButtonToolbar
                    className="form__button-toolbar"
                    style={{ height: 30, width: '100%' }}
                  >
                    <Button
                     
                      className="btn-sm button_enable1 "
                      style={{
                        borderRadius: 5,
                        backgroundColor: "#70bbfd",
                        color: "#fff",
                        width: '100%'
                      }}
                      id="button_view"
                      onClick={this.onReadinessCheck}
                    >
                      {this.state.checkLoader && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      Readiness Check
                    </Button>
                  </ButtonToolbar>
                </div>
              </div>
            }


              <div
                className="form__form-group col-xl-2"
                style={{ display: "inline-flex" }}
              >
                <div
                  className="form__form-group-field col-xl-6"
                  style={{ display: "contents" }}
                >
                  <ButtonToolbar
                    className="form__button-toolbar"
                    style={{ height: 30, }}
                  >
                   {/* <button
                      color="primary"
                      style={{
                        borderRadius: 5,
                        fontSize: '0.875rem',
                        backgroundColor: this.state.enableCreateCycle === true ? '#c1c1c1': "#FBBB00",
                        color: this.state.enableCreateCycle === true ? '#fff': "black",
                       

                      }}
                      id="button_enable"
                      disabled= {this.state.enableCreateCycle}
                      onClick={this.onSubmitBtn}
                    >
                      {this.state.genloading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      Create New
                    </button>*/}

                     <Button
                    className="btn-sm button_enable1 "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                      backgroundColor: this.state.enableCreateCycle === true ? '#c1c1c1': "#FBBB00",
                      color: this.state.enableCreateCycle === true ? '#fff': "black",
                    }}
                    id="button_view"
                     disabled= {this.state.enableCreateCycle}
                      onClick={this.onSubmitBtn}
                  >
                    {this.state.genloading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                     <img
                        src={PlusIcon}
                        alt="Plus"
                        style={{ width: '17px', marginRight: 6 }} // Adjust size as needed
                    />
                    Create New
                  </Button>
                  </ButtonToolbar>
                </div>
              </div>

              <div className="form__form-group col-xl-3">
                <div className="form__form-group-field"></div>
              </div>
            </form>
          

          {this.state.showDashboardData && (
            <div style={{marginTop: 15}}>
              <MDBDataTable
                striped
                bordered
                hover
                onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'CC Dashboard', 'datatable_pagination_change' )}
                data={productData}
                scrollX={true}
              />
            </div>
          )}
      
      <div className="row">
            {this.state.showProcess && (
              <div className="col-xl-12" style={{ marginBottom: 20}}>
                <CardBody style={{ marginTop: 20}}>
                  
                  {this.state.showProcess && (
                    <div
                      className="form__form-group col-xl-12"
                      style={{ display: "inline-flex", marginTop: "10px",marginBottom:'0px' }}
                    >
                      <span
                        className="form__form-group-label col-xl-3"
                        style={{
                          display: "inline",
                          paddingTop: 6,
                          paddingBottom: 6,
                        }}
                      >
                        Selection Mode
                      </span>

                      <div
                        className="form__form-group-field col-xl-9"
                        style={{ display: "inline" }}
                      >
                        <MySelect
                          style={{ width: "100%" }}
                          options={[{"label":"Cycle Count by Bin","value":"1"},{"label":"Cycle Count by Area","value":"2"}]}
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={this.onSelectProcess}
                          value={this.state.selectedProcess}
                        />
                      </div>
                    </div>
                  )}

                </CardBody>
              </div>
            )}
          </div>
    
      {this.state.showBinAddressDropdown && (
            <div class="row">
              <div className="col-xl-12" style={{marginBottom:20}}>
                <CardBody style={{ marginTop: 20 }}>
                  
                  <div
                    className="form__form-group col-xl-12"
                    style={{ display: "inline-flex", marginTop: "10px",marginBottom:'0px' }}
                  >
                    <span
                      className="form__form-group-label col-xl-3"
                      style={{
                        display: "inline",
                        paddingTop: 6,
                        paddingBottom: 6,
                      }}
                    >
                      Bin Address
                    </span>

                    <div
                      className="form__form-group-field col-xl-9"
                      style={{ display: "inline" }}
                    >
                      <input
                        placeholder="Select Bin Address"
                        type="text"
                        style={{
                          padding: 10,
                          borderRadius: 4,
                          width: "100%",
                          fontSize: 13,borderColor: 'hsl(0,0%,80%)',borderStyle: 'solid',borderWidth: '1px'
                        }}
                        value={this.state.selectedBinAddress}
                        onChange={this.onBinAddressKeyup}
                        onBlur={this.onBlurBinAddress}
                      />

                      {this.state.containerOnKeyDown && (
                        <div
                          className="suggestions-container"
                          style={{ height: 150, width: "100%" }}
                          ref={(el) => (this.typeahead = el)}
                        >
                          <div className="suggestions">
                            {this.state.optionForBinAddressDropdown.length >
                              0 &&
                              this.state.optionForBinAddressDropdown.map(
                                (item, index) => (
                                  <p
                                    key={index}
                                    onClick={() =>
                                      this.onSelectBinAddress([item])
                                    }
                                    className="typeahead-text"
                                  >
                                    {item.label}{" "}
                                  </p>
                                )
                              )}
                          </div>
                        </div>
                      )}

                      
                    </div>
                  </div>
                </CardBody>
              </div>
            </div>
          )}
  
    
          <div className="row">
            {this.state.showZone && (
              <div className="col-xl-12" style={{ marginBottom: 20}}>
                <CardBody style={{ marginTop: 20}}>
                  
                  {this.state.showZone && (
                    <div
                      className="form__form-group col-xl-12"
                      style={{ display: "inline-flex", marginTop: "10px" }}
                    >
                      <span
                        className="form__form-group-label col-xl-3"
                        style={{
                          display: "inline",
                          paddingTop: 6,
                          paddingBottom: 6,
                        }}
                      >
                        Zone
                      </span>

                      <div
                        className="form__form-group-field col-xl-9"
                        style={{ display: "inline" }}
                      >
                        <MySelect
                          style={{ width: "100%" }}
                          options={options}
                          isMulti
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={this.onChangeVal3}
                          allowSelectAll={true}
                          value={this.state.optionSelected}
                        />
                      </div>
                    </div>
                  )}

                  {this.state.showAisle && (
                    <div
                      className="form__form-group col-xl-12"
                      style={{ display: "inline-flex" }}
                    >
                      <span
                        className="form__form-group-label col-xl-3"
                        style={{
                          display: "inline",
                          paddingTop: 6,
                          paddingBottom: 6,
                        }}
                      >
                        Aisle{" "}
                      </span>

                      <div
                        className="form__form-group-field col-xl-9"
                        style={{ display: "inline" }}
                      >
                        <MySelect
                          style={{ width: "100%" }}
                          options={this.state.options1}
                          isMulti
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={this.onChangeVal1}
                          allowSelectAll={true}
                          value={this.state.optionSelected1}
                        />
                      </div>
                    </div>
                  )}

                  {this.state.showRack && (
                    <div
                      className="form__form-group col-xl-12"
                      style={{ display: "inline-flex" }}
                    >
                      <span
                        className="form__form-group-label col-xl-3"
                        style={{
                          display: "inline",
                          paddingTop: 6,
                          paddingBottom: 6,
                        }}
                      >
                        Rack{" "}
                      </span>

                      <div
                        className="form__form-group-field col-xl-9"
                        style={{ display: "inline" }}
                      >
                        <MySelect
                          style={{ width: "100%" }}
                          options={this.state.options2}
                          isMulti
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={this.onChangeVal2}
                          allowSelectAll={true}
                          value={this.state.optionSelected2}
                        />
                      </div>
                    </div>
                  )}

                  {this.state.showSubmitBtn && (
                    <div
                      className="form__form-group col-xl-12"
                      style={{ display: "inline-flex" }}
                    >
                      <div
                        className="form__form-group-field col-xl-12"
                        style={{ display: "contents", textAlign: "center" }}
                      >
                        <ButtonToolbar className="form__button-toolbar">
                          <Button
                            color="primary"
                            disabled={this.state.disabledBtn}
                            className="btn-sm show_confirm_button"
                            onClick={this.onSubmitCycleCount}
                            type="submit"
                          >
                            {this.state.loadBinData && (
                              <i
                                className="fa fa-refresh fa-spin"
                                style={{ marginRight: "5px" }}
                              />
                            )}
                            Submit
                          </Button>
                        </ButtonToolbar>
                      </div>
                    </div>
                  )}
                </CardBody>
              </div>
            )}
          </div>
      
          {this.state.showSelectedBin && (
            <CardBody style={{ marginTop: 20 }}>
              <div style={{ width: "100%", marginBottom: 8 }}>
                <span style={{ fontWeight: "bold", fontSize: 15 }}>
                  {" "}
                  Selected Bins ({this.state.SelectedBins.length}){" "}
                </span>
              </div>

              <div style={{ width: "100%" }}>
                {this.state.binData.map(
                  (item, index) =>
                    item.isChecked == true && (
                      <span
                        style={{
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: 13,
                          width: "14%",
                          float: "left",
                          backgroundColor: "#ccc",
                          borderRadius: 6,
                          paddingTop: 4,
                          paddingBottom: 4,
                          marginRight: 8,
                          marginBottom: 5,
                        }}
                      >
                        {" "}
                        {item.bin_address}{" "}<a><i onClick={() => this.removeBin(item.bin_address)}class="fa fa-times" aria-hidden="true" style={{float: 'right', paddingRight: '10px', paddingTop: '4px'}}></i></a>
                      </span>
                    )
                )}
              </div>
        
        {this.state.isdisableBinAssignBtn &&
                    <div
                      className="form__form-group col-xl-12"
                      style={{ display: "inline-flex",margin: '20px 0px',paddingLeft: '0px' }}
                    >
                      <div
                        className="form__form-group-field col-xl-12"
                        style={{ display: "contents", textAlign: "center" }}
                      >
                        <ButtonToolbar className="form__button-toolbar">
                          <Button
                            color="primary"
                            className="btn-sm show_confirm_button"
                            onClick={this.AssignUser}
                            type="submit"
                          >
                            Assign
                          </Button>
                        </ButtonToolbar>
                      </div>
                    </div>
                  }
            </CardBody>
          )}

         
          {this.state.showBinTable && (
            <CardBody style={{ marginTop: 20 }}>
              <div className="table_header">
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    color="primary"
                    disabled={this.state.disabledBtn}
                    className="btn-sm show_confirm_button"
                    onClick={this.AssignUser}
                    type="submit"
                    disabled={this.state.isdisableAssignBtn}
                  >
                    {this.state.loadingconfirmbtn && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Assign
                  </Button>
                </ButtonToolbar>
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        checked={this.state.isChecked}
                        onChange={() => this.checkAll()}
                      />{" "}
                    </th>
                    <th>Bin Address</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.binData.length > 0 &&
                    this.state.binData.map((item, index) => (
                      <tr>
                        <td>
                          {" "}
                          <input
                            type="checkbox"
                            value={item.isChecked}
                            checked={item.isChecked}
                            onChange={() => this.checkedSingle(index, item)}
                          />{" "}
                        </td>
                        <td> {item.bin_address} </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </CardBody>
          )}

          {this.state.showFetchGRNData && (
            <CardBody style={{ marginTop: 20 }}>
              <div className="table_header">
                <span>
                  {" "}
                  <span style={{ fontWeight: "bold" }}> GRN Number: </span>{" "}
                  <span> {this.state.grnValues} / </span>{" "}
                  <span style={{ fontWeight: "bold" }}> GRN Line Number: </span>{" "}
                  <span> {this.state.grnLineValue} </span>
                </span>

                <ButtonToolbar className="form__button-toolbar">
                  {this.state.showAssignButton && (
                    <Button
                      color="primary"
                      className="btn-sm"
                      onClick={this.toggle}
                      type="submit"
                    >
                      Assign
                    </Button>
                  )}
                  {this.state.showPrintButton && (
                    <Button color="primary" className="btn-sm" type="submit">
                      Print
                    </Button>
                  )}
                </ButtonToolbar>
              </div>

              <div className="table_val">
                <MDBTable autoWidth striped>
                  <MDBTableHead columns={GRNData.columns} />
                  <MDBTableHead>
                    {this.state.loadingGRNData && (
                      <div
                        style={{
                          width: "2300%",
                          textAlign: "center",
                          paddingTop: 22,
                        }}
                      >
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px", fontSize: 18 }}
                        />
                      </div>
                    )}
                  </MDBTableHead>
                  <MDBTableBody scrollX rows={GRNData.rows} />
                </MDBTable>
              </div>
            </CardBody>
          )}

          {this.state.showFailedItem && (
            <CardBody style={{ marginTop: 20 }}>
              <div className="table_header">
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    color="primary"
                    disabled={this.state.disabledBtn}
                    className="btn-sm show_confirm_button"
                    onClick={this.confirmData}
                    type="submit"
                  >
                    {this.state.loadingconfirmbtn && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Confirm
                  </Button>
                </ButtonToolbar>
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>Response </th>
                    <th>Bin Address</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.FailedItems.map((item, index) => (
                    <tr>
                      <td style={{ backgroundColor: "red", color: "#fff" }}>
                        {" "}
                        {item.reason}{" "}
                      </td>

                      <td>{item.bin_address}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
          )}
        </Card>

        <Modal
          isOpen={modalAssignUser}
          toggle={this.toggleAssignUser}
          style={{ maxWidth: 700, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Assign Users
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 14 }}>
            <Table
              responsive
              className="table--bordered"
              style={{ marginBottom: 75 }}
            >
              <thead>
                <tr>
                  <th>Zone Id</th>
                  <th>Zone Name</th>
                  <th>Bin Count</th>
                  <th>Users</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(uniqueZoneData).length > 0 &&
                  _.map(uniqueZoneData, (item, key) => (
                    <tr key={key}>
                      <td>{item.zoneId}</td>
                      <td>{item.zoneName} </td>
                      <td>{item.items.length} </td>
                      <td>
                        <div className="form__form-group">
                          <div className="form__form-group-field">
                            <Select
                              isMulti
                              name={`multiSelect_${item.zoneId}`}
                              value={selectedUser[item.zoneId]}
                              onChange={(selectedOptions) =>
                                this.onChangeValStock(selectedOptions, item.id)
                              }
                              options={optionsUser}
                              clearable={true}
                              closeOnSelect={true}
                              removeSelected={true}
                              className="react-select"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>

            <ButtonToolbar className="modal__footer">
              <button
                  className="modal_cancel"
                onClick={this.toggleAssignUser}
              >
                Cancel
              </button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                }}
                className="modal_ok"
                onClick={this.processData}
              >
                {this.state.loadingprintbtn && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Confirm
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal
          isOpen={modalAssignUserCycleCount}
          toggle={this.toggleAssignUserCycleCount}
          style={{ maxWidth: 700, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Assign Users
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 14 }}>
            <div>
              <span style={{ fontWeight: "bold", fontSize: 16 }}>
                {" "}
                Estimated Scan Count :{" "}
                <span style={{ color: "red" }}>
                  {" "}
                  {this.state.totalScanCount}{" "}
                </span>{" "}
              </span>
            </div>
            <Table
              responsive
              className="table--bordered"
              style={{ marginBottom: 75 }}
            >
              <thead>
                <tr>
                  <th>Zone Id</th>
                  <th>Zone Name</th>
                  <th> Bin Count </th>
                  <th>Users</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(uniqueZoneData1).length > 0 &&
                  _.map(uniqueZoneData1, (item, key) => (
                    <tr key={key}>
                      <td>{item.zoneId}</td>
                      <td>{item.zoneName} </td>
                      <td>{item.items.length} </td>
                      <td>
                        <div
                          className="form__form-group"
                          style={{ width: "100%" }}
                        >
                          <div
                            style={{ width: "100%" }}
                            className="form__form-group-field"
                          >
                            <MySelect
                              style={{ width: "100%" }}
                              isMulti
                              name={`multiSelect_${item.zoneId}`}
                              value={selectedUser[item.zoneId]}
                              onChange={(selectedOptions) =>
                                this.onChangeVal(
                                  selectedOptions,
                                  item.zoneId,
                                  item.items
                                )
                              }
                              options={optionsUser}
                              clearable={true}
                              closeOnSelect={true}
                              removeSelected={true}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>

            <ButtonToolbar className="modal__footer">
             <button
                  className="modal_cancel"
                onClick={this.toggleAssignUserCycleCount}
              >
                Cancel
              </button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                }}
                className="modal_ok"
                onClick={this.processData1}
              >
                {this.state.loadingprintbtn && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Confirm
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal
          isOpen={modal}
          toggle={this.toggle}
          style={{ maxWidth: 500, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Assign Users
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 14 }}>
            <form className="form form--inline">
              <div
                className="form__form-group col-xl-10"
                style={{ display: "inline-flex" }}
              >
                <span
                  className="form__form-group-label col-xl-5"
                  style={{
                    display: "inline",
                    paddingTop: 6,
                    paddingBottom: 6,
                    fontWeight: "bold",
                  }}
                >
                  Select User
                </span>

                <div
                  className="form__form-group-field col-xl-7"
                  style={{ display: "contents" }}
                >
                  <Field
                    name="select"
                    label="Select"
                    component={renderSelectField}
                    placeholder="Select User"
                    onChange={this.change1}
                    options={[
                      { value: "user1", label: "WMS User" },
                      { value: "test", label: "Test User" },
                    ]}
                  />
                </div>
              </div>

              <div className="form__form-group col-xl-3">
                <div className="form__form-group-field"></div>
              </div>
            </form>

            <ButtonToolbar className="modal__footer">
              <button
                  className="modal_cancel"
                onClick={this.togglePressCancel}
              >
                Cancel
              </button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                }}
                className="modal_ok"
                onClick={this.processData}
              >
                {this.state.loadingprintbtn && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Submit
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal isOpen={successModal} toggle={this.successToggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.successToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> Sucessfully Updated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.successToggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={successMessageModal} toggle={this.successMessageToggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.successMessageToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4>{this.state.success_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.successMessageToggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={messageModal} toggle={this.messagetoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.alertMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
              style={{  marginRight: 8 }}
              className="modal_cancel"
              onClick={this.toggle}
            >
              Cancel
            </button>
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.cancelMessageModal}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={cycleCountCancelModal} toggle={this.onCancelCycleModal}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.onCancelCycleModal}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> Are you sure you want to cancel ? </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
              style={{ marginRight: 8 }}
              className="modal_cancel"
              onClick={this.onCancelCycleModal}
            >
              Cancel
            </button>
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.onCancel}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={messageModalCycle} toggle={this.messageToggleCycle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.messageToggleCycle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.alertMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
              style={{  marginRight: 8 }}
              className="modal_cancel"
              onClick={this.messageToggleCycle}
            >
              Cancel
            </button>
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.cancelMessageModalCycle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={modalfailed} toggle={this.failedToggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15, }}
              onClick={this.failedToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />

            <h4> {this.state.failedMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
           <button
                  className="modal_cancel"
              onClick={this.failedToggleCancel}
            >
              Cancel
            </button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={modalCancel} toggle={this.cancelToggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.cancelToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.cancelReason} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
                  className="modal_cancel"
              onClick={this.cancelToggle}
            >
              Cancel
            </button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={modalfailedCycle} toggle={this.failedToggleCycle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.failedToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.failedMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
           <button
                  className="modal_cancel"
              onClick={this.failedToggleCancelCycle}
            >
              Cancel
            </button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={modalReport}
          toggle={this.toggleReports}
          style={{ maxWidth: 500, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Download Reports
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 12 }}>
            <div style={{ width: "100%" }}>
              <table style={{ width: "100%" }}>
                <tr>
                  <td>SKU Level and PKM level Report</td>

                  <td>
                    <span
                      style={{
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontSize: 15,
                        color: "rgb(112, 187, 253)",
                      }}
                      onClick={this.downloadSKU}
                    >
                      {" "}
                      Export to Excel{" "}
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>Physical Excess Stock Report</td>

                  <td>
                    <span
                      style={{
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontSize: 15,
                        color: "rgb(112, 187, 253)",
                      }}
                      onClick={this.downloadExcessStock}
                    >
                      {" "}
                      Export to Excel{" "}
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>Complete Stock Report</td>

                  <td>
                    <span
                      style={{
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontSize: 15,
                        color: "rgb(112, 187, 253)",
                      }}
                      onClick={this.downloadCompleteStock}
                    >
                      {" "}
                      Export to Excel{" "}
                    </span>
                  </td>
                </tr>

                <tr>
                  <td colspan="2" style={{ textAlign: "center" }}>
                    <ButtonToolbar
                      className="modal__footer"
                      style={{ paddingTop: 12, paddingBottom: 20 }}
                    >
                      <button
                  className="modal_cancel"
                        onClick={this.closeReportModal}
                      >
                        Cancel
                      </button>
                    </ButtonToolbar>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </Modal>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
